export enum BrazeCustomAttributes {
  ACCOUNT_HAS_COPILOT_TRIAL_EXPIRED = 'account_has_copilot_trial_expired',
  ACCOUNT_HAS_COPILOT_TRIAL = 'account_has_copilot_trial',
  ACCOUNT_HAS_COPILOT = 'account_has_copilot',
  ACCOUNT_HAS_MILEON = 'account_has_mileOn',
  PARTNER_CODE = 'partner_code',
  PARTNER_NAME = 'partner_name',
  COMPANY_CODE = 'company_code',
  COMPANY_NAME = 'company_name',
  DAYS_UNTIL_NEXT_COPILOT_EXPIRY = 'days_until_next_copilot_expiry',
  ACCOUNT_HAS_WEATHER = 'account_has_weather',
  ACCOUNT_HAS_CONTENTTOOLS = 'account_has_contenttools',
  ACCOUNT_HAS_MAPSURE = 'account_has_mapsure',
  ACCOUNT_HAS_PCMWEB = 'account_has_pcmweb',
  ACCOUNT_HAS_MAPEXACT = 'account_has_mapexact',
  ACCOUNT_HAS_ROUTEREPORTER = 'account_has_routereporter',
  ACCOUNT_NUM_AFSETS = 'account_num_afsets',
  ACCOUNT_NUM_CUSTOMPLACES = 'account_num_customplaces',
  ACCOUNT_NUM_VRPS = 'account_num_vrps',
  ACCOUNT_NUM_MAPSETS = 'account_num_mapsets',
  ACCOUNT_NUM_CONFIGPROFILES = 'account_num_configprofiles',
  ACCOUNT_NUM_ASSETS = 'account_num_assets',
  ACCOUNT_HAS_TRAFFIC = 'account_has_traffic',
  ACCOUNT_PREFERRED_LANGUAGE = 'account_preferred_language',
  DATA_REGION = 'data_region',
  EXPANDED_CARDS = 'expanded_cards',
  INTERESTED_IN_ROUTEREPORTER = 'interested_in_routereporter',
  DARK_MODE = 'dark_mode',
}
